import React, { useState } from "react";
import { Link } from "react-router-dom";

const faqs = [
  {
    question: "Do you charge a fee for your mortgage advice?",
    answer:
      "In most cases, our mortgage advice is paid for by the lender when your loan settles, not by you. If a fee is ever required for a specialist situation, we’ll explain it clearly upfront so there are no surprises.",
  },
  {
    question: "Can you work with my current bank as well as others?",
    answer:
      "Yes. We work with a wide range of New Zealand banks and specialist lenders, so your own bank’s offer goes next to everyone else’s and you can see the difference in rate and structure for yourself.",
  },
  {
    question: "I’m a first-home buyer. When should I talk to you?",
    answer:
      "As early as possible, ideally before you start going to open homes. We can work out what you are likely to be able to borrow and how your deposit and KiwiSaver fit in. Then we will tell you exactly what a bank wants to see before it will pre-approve you.",
  },
  {
    question: "Do you only help people in Auckland?",
    answer:
      "No. We are based in Auckland, but most of this works fine over video, phone and email, and plenty of our clients are elsewhere in the country. If you are nearby, come in and see us.",
  },
  {
    question: "Can you help with refinancing or restructuring an existing loan?",
    answer:
      "Yes. We look at your current rate, your loan structure and how long you have left to run, then tell you whether moving is worth the effort. Sometimes it isn’t, and we’ll say so.",
  },
  {
    question: "Do you also look after insurance?",
    answer:
      "Yes. Life, income, health and mortgage protection. It is worth sorting at the same time as the loan, because how much cover you need is largely decided by the debt you have just taken on.",
  },
];

function FAQItem({ faq, index, isOpen, onToggle }) {
  const buttonId = `faq-question-${index}`;
  const panelId = `faq-answer-${index}`;

  return (
    <div className={`faq-item ${isOpen ? "open" : ""}`}>
      <h3 className="faq-item-heading">
        <button
          id={buttonId}
          type="button"
          className="faq-question"
          onClick={onToggle}
          aria-expanded={isOpen}
          aria-controls={panelId}
        >
          <span className="faq-number">
            {String(index + 1).padStart(2, "0")}
          </span>
          <span className="faq-question-text">{faq.question}</span>
          <span className="faq-toggle" aria-hidden="true" />
        </button>
      </h3>
      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        className="faq-answer-wrapper"
      >
        <div className="faq-answer-inner">
          <p className="faq-answer">{faq.answer}</p>
        </div>
      </div>
    </div>
  );
}

function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (idx) => {
    setOpenIndex((current) => (current === idx ? null : idx));
  };

  return (
    <section className="section faq-section">
      <div className="faq-grid">
        {/* Left column – intro and a way out if the question isn't listed */}
        <aside className="faq-intro">
          <span className="faq-kicker">FAQ</span>
          <h2 className="faq-title">Questions we’re often asked.</h2>
          <p className="faq-lead">
            These are the ones that come up on almost every first call, so they
            are probably worth answering before you pick up the phone.
          </p>

          <div className="faq-cta">
            <p className="faq-cta-title">Yours not here?</p>
            <p className="faq-cta-text">
              Book a free chat and ask us directly. No obligation.
            </p>
            <div className="faq-cta-actions">
              <Link to="/contact" className="faq-cta-btn">
                Book a free chat
                <span aria-hidden="true">→</span>
              </Link>
              <a href="tel:+6492176765" className="faq-cta-phone">
                or call 09-2176765
              </a>
            </div>
          </div>
        </aside>

        {/* Right column – interactive list */}
        <div className="faq-list">
          {faqs.map((faq, idx) => (
            <FAQItem
              key={faq.question}
              faq={faq}
              index={idx}
              isOpen={openIndex === idx}
              onToggle={() => handleToggle(idx)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
